export default "__VITE_ASSET__c36lwk0R__"